export default __webpack_public_path__ + "assets/8ffcce641d1b65752c20d482a32518a3.svg";